export default (ref) => {
  if (!!ref?.current?.value) {
    ref.current.value = '';
  }
};
